import * as React from 'react'
import moment from 'moment'
import type { Moment } from 'moment'

import { AdminDateField } from '@/modules/shared/components'
import { useLocalize } from '@/modules/shared/context/localize/LocalizeContext'
import { AdminModal, AdminModalRow } from '@/modules/adminPanel/shared/AdminModal'

type Props = {
  dateTo: Moment
  name: string
  /** `(null, null)` = anulowano; inaczej nowa data i nazwa firmy demo. */
  onClose: (dateTo: Moment | null, name: string | null) => void
}

/**
 * Przedłużenie firmy demo.
 *
 * Było klasą z `componentWillReceiveProps` na shimie bootstrapowym, z układem
 * zbudowanym z zagnieżdżonych `FlexView` i stylami inline. Teraz to funkcja
 * na `AdminModal`, czyli tym samym szkielecie co reszta modali panelu.
 */
export const ExtendDemoModal: React.FC<Props> = ({
  dateTo: initialDateTo,
  name: initialName,
  onClose,
}) => {
  const { t } = useLocalize()
  const [dateTo, setDateTo] = React.useState<Moment>(initialDateTo)
  const [name, setName] = React.useState(initialName)

  return (
    <AdminModal
      width={560}
      title={t('extend-demo-modal.title')}
      onClose={() => onClose(null, null)}
      onConfirm={() => onClose(dateTo, name)}
      confirmLabel={t('operation.save')}
    >
      <AdminModalRow label={t('extend-demo-modal.name')}>
        <input
          autoFocus
          id="name"
          className="tw-h-9 tw-w-full tw-rounded-md tw-border tw-border-base-300 tw-px-2 tw-text-sm focus:tw-border-primary focus:tw-outline-none"
          value={name ?? ''}
          onChange={(event) => setName(event.target.value)}
        />
      </AdminModalRow>

      <AdminModalRow label={t('extend-demo-modal.extend-until')}>
        <div className="tw-w-[200px]">
          <AdminDateField
            withTime
            value={dateTo}
            onChange={(value) => {
              if (value == null) return
              setDateTo(moment(value))
            }}
          />
        </div>
      </AdminModalRow>
    </AdminModal>
  )
}

export default ExtendDemoModal
